import { messaging } from './_helpers/firebase.config';
import { userService } from './_services';
// This optional code is used to register a service worker.
// register() is not called by default.

// This lets the app load faster on subsequent visits in production, and gives
// it offline capabilities. However, it also means that developers (and users)
// will only see deployed updates on subsequent visits to a page, after all the
// existing tabs open on the page have been closed, since previously cached
// resources are updated in the background.

// To learn more about the benefits of this model and instructions on how to
// opt-in, read https://bit.ly/CRA-PWA

const isLocalhost = Boolean(
  window.location.hostname === 'localhost' ||
    // [::1] is the IPv6 localhost address.
    window.location.hostname === '[::1]' ||
    // 127.0.0.0/8 are considered localhost for IPv4.
    window.location.hostname.match(
      /^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/
    )
);

export function register(config) {
  //if (process.env.NODE_ENV === 'production' && 'serviceWorker' in navigator) {
    if ( 'serviceWorker' in navigator) { 
    // The URL constructor is available in all browsers that support SW.
    const publicUrl = new URL(process.env.PUBLIC_URL, window.location.href);
    if (publicUrl.origin !== window.location.origin) {
      // Our service worker won't work if PUBLIC_URL is on a different origin
      // from what our page is served on. This might happen if a CDN is used to
      // serve assets; see https://github.com/facebook/create-react-app/issues/2374
      return;
    }

    window.addEventListener('load', () => {
      const swUrl = `${process.env.PUBLIC_URL}/sw.js`;

      if (isLocalhost) {
        // This is running on localhost. Let's check if a service worker still exists or not.
        checkValidServiceWorker(swUrl, config);

        // Add some additional logging to localhost, pointing developers to the
        // service worker/PWA documentation.
        navigator.serviceWorker.ready.then(() => {
          console.log(
            'This web app is being served cache-first by a service ' +
              'worker. To learn more, visit https://bit.ly/CRA-PWA'
          );
        });
      } else {
        // Is not localhost. Just register service worker
        registerValidSW(swUrl, config);
      }
    });
  }
}

function registerValidSW(swUrl, config) {
  navigator.serviceWorker
    .register(swUrl)
    .then(registration => {
      registration.onupdatefound = () => {
        const installingWorker = registration.installing;
        if (installingWorker == null) {
          return;
        }
        installingWorker.onstatechange = () => {
          if (installingWorker.state === 'installed') {
            if (navigator.serviceWorker.controller) {
              // At this point, the updated precached content has been fetched,
              // but the previous service worker will still serve the older
              // content until all client tabs are closed.
              console.log(
                'New content is available and will be used when all ' +
                  'tabs for this page are closed. See https://bit.ly/CRA-PWA.'
              );

              // Execute callback
              if (config && config.onUpdate) {
                config.onUpdate(registration);
              }
            } else {
              // At this point, everything has been precached.
              // It's the perfect time to display a
              // "Content is cached for offline use." message.
              console.log('Content is cached for offline use.');

              // Execute callback
              if (config && config.onSuccess) {
                config.onSuccess(registration);
              }
            }
          }
        };
      };
    })
    .catch(error => {
      console.error('Error during service worker registration:', error);
    });
}

function checkValidServiceWorker(swUrl, config) {
  // Check if the service worker can be found. If it can't reload the page.
  fetch(swUrl, {
    headers: { 'Service-Worker': 'script' },
  })
    .then(response => {
      // Ensure service worker exists, and that we really are getting a JS file.
      const contentType = response.headers.get('content-type');
      if (
        response.status === 404 ||
        (contentType != null && contentType.indexOf('javascript') === -1)
      ) {
        // No service worker found. Probably a different app. Reload the page.
        navigator.serviceWorker.ready.then(registration => {
          registration.unregister().then(() => {
            window.location.reload();
          });
        });
      } else {
        // Service worker found. Proceed as normal.
        registerValidSW(swUrl, config);
      }
    })
    .catch(() => {
      console.log(
        'No internet connection found. App is running in offline mode.'
      );
    });
}

export async function pushSubscribeUser() {
  try {
    // 1. Verificar que Service Worker esté soportado
    if (!('serviceWorker' in navigator)) {
      throw new Error('Service Worker no es soportado en este navegador');
    }

    // 2. Verificar que Push Manager esté soportado
    if (!('PushManager' in window)) {
      throw new Error('Push notifications no son soportadas en este navegador');
    }

    // 3. Obtener el registro del Service Worker
    const registration = await navigator.serviceWorker.getRegistration();
    if (!registration) {
      throw new Error('No se encontró un Service Worker registrado');
    }

    const currentToken = await messaging.getToken({ 
      vapidKey: 'BEllKT_BHDi5wePj_PGe2CqnsuIkwv1J3vTNjSSZC4GDM1k2j1NcuFkQt6qHKDRBj3uUfIMdKaeNXXzpvZjiPKA',
      serviceWorkerRegistration: registration
     });

    // 6. Procesar y enviar la suscripción al servidor
    const uniqueDeviceId = await processAndSendSubscription(currentToken);
    
    return {endpoint: currentToken, auth: uniqueDeviceId};
    
  } catch (error) {
    console.error('Error en pushSubscribeUser:', error);
    throw error;
  }
}


// Función auxiliar para procesar la suscripción
export async function processAndSendSubscription(currentToken) {
  try {

    const uniqueDeviceId = getOrCreateDeviceId();    
    await userService.grabarPushSuscripcion(currentToken, uniqueDeviceId);
    console.log('Suscripción guardada exitosamente en el servidor');
    return uniqueDeviceId;
  } catch (error) {
    console.error('Error al procesar suscripción:', error);
    throw error;
  }
}

export const generateDeviceId = () => {
  return 'device_' + Date.now() + '_' + Math.random().toString(36).substr(2, 9);
};

const STORAGE_KEY = 'deviceId';

export const getDeviceId = () =>{   
  let deviceId = localStorage.getItem(STORAGE_KEY);
  return deviceId;
}

export const getOrCreateDeviceId = () => {
  
  try {
    let deviceId = localStorage.getItem(STORAGE_KEY);
    
    if (!deviceId) {
      deviceId = generateDeviceId();
      localStorage.setItem(STORAGE_KEY, deviceId);
    }
    
    return deviceId;
  } catch (error) {
    // Fallback si localStorage no está disponible
    console.error('Error accessing localStorage:', error);
    return generateDeviceId();
  }
};

export function estoyPermitido(){
  return Notification.permission == 'granted';
}

export function displayNotification(mensaje) {
  
  if (Notification.permission == 'granted') {
    navigator.serviceWorker.getRegistration().then(function(reg) {
      var options = {
        body: mensaje,
        icon: 'images/lock.png',
        vibrate: [100, 50, 100],
        data: {
          dateOfArrival: Date.now(),
          primaryKey: 1
        }
      };
      //reg.showNotification('IOTECH: Nuevo aviso',options);
    });
  }
}

export function unregister() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready
      .then(registration => {
        registration.unregister();
      })
      .catch(error => {
        console.error(error.message);
      });
  }
}



